module.exports = __webpack_public_path__ + "777cdbe0c0397e18bca2e497d3775e6d.png";